export enum WebOnboardingStep {
  GetToKnowYou = "GetToKnowYou",
  TeamJoinCreate = "TeamJoinCreate",
  AIScheduler = "AIScheduler",
  Links = "Links",
  Carousel = "Carousel",
  Invite = "Invite",
  FlexMeeting = "FlexMeeting",
  FocusTime = "FocusTime",
  Lunch = "Lunch",
  DownloadClockwise = "DownloadClockwise",
  Slack = "Slack",
  Finished = "Finished",
}

export const getFlowStateEnumFromString = (flowState: string) => {
  if (flowState in WebOnboardingStep) {
    return flowState as WebOnboardingStep;
  }
  return WebOnboardingStep.GetToKnowYou;
};

export const WebOnboardingStepList = [
  WebOnboardingStep.GetToKnowYou,
  WebOnboardingStep.TeamJoinCreate,
  WebOnboardingStep.AIScheduler,
  WebOnboardingStep.Links,
  WebOnboardingStep.Carousel,
  WebOnboardingStep.FlexMeeting,
  WebOnboardingStep.FocusTime,
  WebOnboardingStep.Lunch,
  WebOnboardingStep.Invite,
  WebOnboardingStep.DownloadClockwise,
  WebOnboardingStep.Slack,
  WebOnboardingStep.Finished,
];

export const skipableWebOnboardingStepMap = {
  [WebOnboardingStep.GetToKnowYou]: false,
  [WebOnboardingStep.TeamJoinCreate]: false,
  [WebOnboardingStep.AIScheduler]: true,
  [WebOnboardingStep.Links]: true,
  [WebOnboardingStep.Carousel]: false,
  [WebOnboardingStep.FlexMeeting]: false,
  [WebOnboardingStep.FocusTime]: false,
  [WebOnboardingStep.Lunch]: false,
  [WebOnboardingStep.Invite]: false,
  [WebOnboardingStep.DownloadClockwise]: true,
  [WebOnboardingStep.Slack]: true,
  [WebOnboardingStep.Finished]: false,
};

export type StepComponentMapType = {
  [key in WebOnboardingStep]: JSX.Element;
};

// solely for use of the step counter component
// We have slides that only show up conditionally. If those slides are before other slides, they likely affect the step count.
// In that case, you want to place the slide that affects the step count in the "countAffectedBy", so that we add +1 value per conditional slide
// IF the orders are ever changed, make sure to update this object
export const stepCounterSteps: Record<
  WebOnboardingStep,
  { defaultStepCount: number | null; countAffectedBy: WebOnboardingStep[] }
> = {
  [WebOnboardingStep.GetToKnowYou]: {
    defaultStepCount: 1,
    countAffectedBy: [],
  },
  [WebOnboardingStep.TeamJoinCreate]: {
    defaultStepCount: 2,
    countAffectedBy: [],
  },
  [WebOnboardingStep.AIScheduler]: {
    defaultStepCount: 3,
    countAffectedBy: [],
  },
  [WebOnboardingStep.Links]: {
    defaultStepCount: 3,
    countAffectedBy: [WebOnboardingStep.AIScheduler],
  },
  [WebOnboardingStep.Carousel]: {
    defaultStepCount: 3,
    countAffectedBy: [WebOnboardingStep.Links, WebOnboardingStep.AIScheduler],
  },
  [WebOnboardingStep.FlexMeeting]: {
    defaultStepCount: 4,
    countAffectedBy: [WebOnboardingStep.Links, WebOnboardingStep.AIScheduler],
  },
  [WebOnboardingStep.FocusTime]: {
    defaultStepCount: 5,
    countAffectedBy: [WebOnboardingStep.Links, WebOnboardingStep.AIScheduler],
  },
  [WebOnboardingStep.Lunch]: {
    defaultStepCount: 6,
    countAffectedBy: [WebOnboardingStep.Links, WebOnboardingStep.AIScheduler],
  },
  [WebOnboardingStep.Invite]: {
    defaultStepCount: 7,
    countAffectedBy: [WebOnboardingStep.Links, WebOnboardingStep.AIScheduler],
  },
  [WebOnboardingStep.DownloadClockwise]: {
    defaultStepCount: 8,
    countAffectedBy: [WebOnboardingStep.Links, WebOnboardingStep.AIScheduler],
  },
  [WebOnboardingStep.Slack]: {
    defaultStepCount: 8,
    countAffectedBy: [WebOnboardingStep.Links, WebOnboardingStep.AIScheduler],
  },
  [WebOnboardingStep.Finished]: {
    defaultStepCount: null,
    countAffectedBy: [],
  },
};
